import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Canvas({ apiResponse }) {

    console.log('apiResponse', apiResponse);
    const navigate = useNavigate();
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        const { orgLogo, assemblyPointMarker, smarker, fixtureMarkers, courseName, ccqrcodeurl } = apiResponse;

        const framepaddingcolor = 'white';
        let fixtures = 0;
        let incidents = 0;
        const dpi = 300;
        const pagew = 8.5;
        const pageh = 11;
        const actualw = 6.75;
        const actualh = 9.25;

        const sizeW = pagew * dpi;
        const sizeH = pageh * dpi;

        const startX = ((pagew - actualw) * dpi) / 2;
        const startY = ((pageh - actualh) * dpi) / 2;

        canvas.width = sizeW;
        canvas.height = sizeH;
        ctx.lineWidth = "2";
        ctx.strokeStyle = "black";
        ctx.font = `100 16px "Open Sans",sans-serif`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.lineWidth = 1;
        ctx.globalCompositeOperation = "source-over";

        if (framepaddingcolor !== 'white') {
            ctx.beginPath();
            ctx.rect(startX, startY, actualw * dpi, actualh * dpi);
            ctx.stroke();
        }

        const drawCCLinkMarker = (qrcode, label) => {
            if (!qrcode || !label) return; // Skip if data is missing

            const boxw = 580;
            const boxh = 240;

            let localY = (startY + 10);
            let localX = startX + 10;
            if (incidents > 1) {
                localY += 1200;
            }

            ctx.lineWidth = 4;
            ctx.fillStyle = framepaddingcolor;

            ctx.beginPath();
            ctx.roundRect(localX, localY, boxw + 30, boxh + 30, 20);
            ctx.fill();

            ctx.fillStyle = 'white';
            ctx.beginPath();
            ctx.roundRect(localX + 20, localY + 20, boxw - 15, boxh - 15, 20);
            ctx.stroke();
            ctx.fill();
            ctx.fillStyle = null;
            ctx.lineWidth = 1;

            const qrimg = new Image();
            qrimg.onload = () => {
                ctx.drawImage(qrimg, localX + (boxw / 2) + 80, localY + 34, 200, 200);
                ctx.strokeText(label.slice(0, 35), localX + 80 + (boxw / 5), localY + 100);
                if (label.length > 35) {
                    ctx.strokeText(label.slice(35, 70), localX + 80 + (boxw / 5), localY + 140);
                }
            };
            qrimg.onerror = (err) => console.error("Error loading QR code image:", err);
            qrimg.src = qrcode;
        };

        const drawStartingMarker = (qrcode, label) => {
            if (!qrcode || !label) return; // Skip if data is missing

            const boxw = 543;
            const boxh = 665;

            let localY = (startY + 320);
            let localX = startX + 20;
            if (incidents > 1) {
                localY += 1200;
            }

            const bgimg = new Image();
            bgimg.onload = () => {
                ctx.drawImage(bgimg, localX + 12, localY + 50, boxw, boxh);

                const frame = new Image();
                frame.onload = () => {
                    ctx.drawImage(frame, localX + 40, localY + 80, boxw * .9, boxh * .9);
                    ctx.strokeText(label, localX + (boxw / 2), localY + 180);

                    const logoimg = new Image();
                    logoimg.onload = () => {
                        ctx.drawImage(logoimg, localX + (boxw / 2) - 40, localY + boxh - 90, 100, 45);
                    };
                    logoimg.onerror = (err) => console.error("Error loading logo image:", err);
                    logoimg.src = orgLogo || '/images/logo.png';

                    const img = new Image();
                    img.onload = () => {
                        ctx.drawImage(img, localX + 110, localY + 200, 350, 350);
                    };
                    img.onerror = (err) => console.error("Error loading QR code image:", err);
                    img.src = qrcode;
                };
                frame.onerror = (err) => console.error("Error loading frame image:", err);
                frame.src = '/images/smarker-frame.png';
            };
            bgimg.onerror = (err) => console.error("Error loading background image:", err);
            bgimg.src = `/images/smarker-${framepaddingcolor}.png`;
        };

        const drawAssemblyPoint = (qrcode, label) => {
            if (!qrcode || !label) return; // Skip if data is missing

            const boxw = 432;
            const boxh = 460;

            let localY = (startY + 1120);
            let localX = startX + 20;
            if (incidents > 1) {
                localY += 1200;
            }

            ctx.lineWidth = 4;
            ctx.fillStyle = framepaddingcolor;

            ctx.beginPath();
            ctx.roundRect(localX, localY, boxw + 30, boxh + 30, 20);
            ctx.fill();

            ctx.fillStyle = 'white';
            ctx.beginPath();
            ctx.roundRect(localX + 20, localY + 20, boxw - 15, boxh - 15, 20);
            ctx.stroke();
            ctx.fill();
            ctx.fillStyle = null;
            ctx.lineWidth = 1;

            const logoimg = new Image();
            logoimg.onload = () => {
                ctx.drawImage(logoimg, localX + (boxw / 2) - 40, localY + boxh - 45, 100, 45);
            };
            logoimg.onerror = (err) => console.error("Error loading logo image:", err);
            logoimg.src = orgLogo || '/images/logo.png';

            const img = new Image();
            img.onload = () => {
                ctx.drawImage(img, localX + 50, localY + 60, 350, 350);
                ctx.strokeText(label, localX + (boxw / 2), localY + 45);
            };
            img.onerror = (err) => console.error("Error loading QR code image:", err);
            img.src = qrcode;
        };

        const drawFixture = (qrcode, label) => {
            if (!qrcode || !label) return; // Skip if data is missing

            const boxw = 432;
            const boxh = 460;
            fixtures += 1;

            if (fixtures > 6) {
                return;
            }

            let localX = startX + (actualw * dpi / 2);
            if (fixtures % 2 === 0) {
                localX += boxw + 130;
            }

            let localY = startY + 20;
            if (fixtures >= 3) {
                localY += boxh + 100;
            }
            if (fixtures >= 5) {
                localY += boxh + 100;
            }

            ctx.lineWidth = 4;
            ctx.fillStyle = framepaddingcolor;

            ctx.beginPath();
            ctx.roundRect(localX - 15, localY - 15, boxw + 30, boxh + 30, 20);
            ctx.fill();

            ctx.fillStyle = 'white';
            ctx.beginPath();
            ctx.roundRect(localX + 7.5, localY + 7.5, boxw - 15, boxh - 15, 20);
            ctx.stroke();
            ctx.fill();
            ctx.fillStyle = null;
            ctx.lineWidth = 1;

            const logoimg = new Image();
            logoimg.onload = () => {
                ctx.drawImage(logoimg, localX + (boxw / 2) - 50, localY + boxh - 60, 100, 45);
            };
            logoimg.onerror = (err) => console.error("Error loading logo image:", err);
            logoimg.src = orgLogo || '/images/logo.png';

            const img = new Image();
            img.onload = () => {
                ctx.drawImage(img, localX + 40, localY + 45, 350, 350);
                ctx.strokeText(label, localX + (boxw / 2), localY + 30);
            };
            img.onerror = (err) => console.error("Error loading QR code image:", err);
            img.src = qrcode;
        };

        const drawIncident = (qrcode, label, frame) => {
            if (!qrcode || !label || !frame) return; // Skip if data is missing

            const boxw = 345 * 1.7;
            const boxh = 444 * 1.7;

            incidents += 1;

            let localY = (startY + 5);
            if (fixtures >= 1) {
                localY = (Math.round(fixtures / 2) * 440) + (startY + 5) + (440 * 1.35)
            }

            let localX = startX + 5;
            if (incidents > 1) {
                localX += (incidents - 1) * (boxw + 100);
            }

            const frameimg = new Image();
            frameimg.onload = () => {
                ctx.drawImage(frameimg, localX + 27, localY + 59, boxw - 30, boxh - 30);
                ctx.strokeText(label, localX + (boxw / 2), localY + 200);

                const qrimg = new Image();
                qrimg.onload = () => {
                    ctx.drawImage(qrimg, localX + 175, localY + 220, 260, 260);
                };
                qrimg.onerror = (err) => console.error("Error loading QR code image:", err);
                qrimg.src = qrcode;

                const logoimg = new Image();
                logoimg.onload = () => {
                    ctx.drawImage(logoimg, localX + (boxw / 2) - 50, localY + boxh - 260, 100, 45);
                };
                logoimg.onerror = (err) => console.error("Error loading logo image:", err);
                logoimg.src = orgLogo || '/images/logo.png';
            };
            frameimg.onerror = (err) => console.error("Error loading frame image:", err);
            frameimg.src = `/images/${frame}`;
        };

        // Draw elements based on API response
        drawCCLinkMarker(ccqrcodeurl, courseName);

        if (smarker) {
            drawStartingMarker(smarker.qrcodeimg, smarker.name);
        }

        if (assemblyPointMarker) {
            drawAssemblyPoint(assemblyPointMarker.qrcodeimg, assemblyPointMarker.name);
        }

        fixtureMarkers.forEach(marker => {
            if (marker.fixtures) {
                marker.fixtures.forEach(fixture => {
                    drawFixture(fixture.qrcodeimg, fixture.name);
                });
            }
            if (marker.incidents) {
                marker.incidents.forEach(incident => {
                    drawIncident(incident.qrcodeimg, incident.name, incident.frameimg);
                });
            }
        });

    }, [apiResponse]);

    return (
        <>
            <canvas ref={canvasRef}></canvas>
        </>
    );
}

export default Canvas;